<template>
  <div class="header">
    <div class="header-left">{{ beginTimeStamp }}-{{ roomId }}</div>
    <div class="header-right">
      <div class="header-right-time" @click="checkInChange">
        <div id="timer2" v-html="time"></div>
        <div class="onoffswitch" v-if="isCheckAll == true">
          <input
            type="checkbox"
            name="switch"
            class="onoffswitch-checkbox"
            id="switch_00"
            checked=""
            @click="checkAll()"
            v-model="isCheckAll"
            ref="toEndButton"
          />

          <label class="onoffswitch-label" for="switch_00">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>

        <div class="onoffswitch" v-if="isCheckAll == false">
          <input
            type="checkbox"
            name="switch"
            class="onoffswitch-checkbox"
            id="switch_00"
            checked=""
            @click="checkAll()"
            v-model="isCheckAll"
            :disabled="countdownTimerDisable"
            ref="toStartButton"
          />
          <label
            class="onoffswitch-label"
            for="switch_00"
            :class="{ 'disabled-switch': countdownTimerDisable }"
          >
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>
      </div>
      <div
        class="header-right-record"
        @click="screenShareOpen"
        :class="{
          disabled:
            countdownTimerDisable || (!countdownTimerDisable && recordState),
        }"
      >
        Record
        <img
          src="@/assets/image/icon-record.png"
          alt=""
          :class="{ 'blinking-icon': recordState }"
        />
      </div>

      <el-popover
        placement="bottom"
        trigger="hover"
        popper-class="header-popover"
      >
        <div class="header-right-icon" slot="reference">
          <img src="@/assets/image/icon-menu.png" alt="" />
        </div>
        <div class="header-right-box">
          <div class="header-right-icon" @click="jumpClick('LR')">
            <img src="@/assets/image/icon-jumpLR.png" alt="" />
          </div>
          <div class="header-right-icon" @click="jumpClick('TB')">
            <img src="@/assets/image/icon-jumpTB.png" alt="" />
          </div>
        </div>
      </el-popover>

      <div class="header-right-icon" @click="serviceOpen">
        <img src="@/assets/image/icon-service.png" alt="" />
      </div>
      <div class="header-right-icon" @click="deviceOpen">
        <img src="@/assets/image/icon-setting.png" alt="" />
      </div>
      <div class="header-right-icon" @click="quitOpen">
        <img src="@/assets/image/icon-quit.png" alt="" />
      </div>
    </div>

    <!-- 打卡填資料彈窗 -->
    <transition name="el-fade-in">
      <div class="popup" v-show="checkInShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box checkIn-box" v-if="checkInShow">
            <div class="box-img">
              <img src="@/assets/image/popup-fillIn.png" alt="" />
            </div>
            <h3 class="box-h3">請完成課後必填資料</h3>
            <h5 class="box-h5">Fill out required columns.</h5>
            <button class="box-btn" @click="checkInClose">Click Here</button>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 熒幕分享彈窗 -->
    <transition name="el-fade-in">
      <div class="popup" v-show="screenShareShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box screenShare-box" v-if="screenShareShow">
            <h3 class="box-h3">
              請點擊下方「錄製螢幕畫面」<br />
              並且選擇「Chrome分頁」進行上課
            </h3>
            <h5 class="box-h5">
              Click below button and choose "Chrome Tab" to <br />
              proceed the class.
            </h5>
            <div class="box-btn">
              <button @click="screenShareClose" :class="{ disabled: isRecordingTransitioning }">
                <p>錄製螢幕畫面</p>
                <span>Record your screen.</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 呼叫客服彈窗 -->
    <transition name="el-fade-in">
      <div class="popup" v-show="serviceShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box service-box" v-if="serviceShow">
            <div class="box-img">
              <img src="@/assets/image/popup-service.png" alt="" />
            </div>
            <h3 class="box-h3">是否呼叫客服？</h3>
            <h5 class="box-h5">
              Do you want to call a real-time customer service?
            </h5>
            <div class="box-btn">
              <button class="button1" @click="serviceCancel">
                <p>取消</p>
                <span>Cancel</span>
              </button>
              <button @click="serviceSubmit">
                <p>確定</p>
                <span>YES</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 客服呼叫成功彈窗 -->
    <transition name="el-zoom-in-center">
      <div class="notify-popup" v-show="serviceNotifyShow">
        <p class="notify-popup-p">顯示</p>
        <p class="notify-popup-p">已經成功呼叫客服</p>
        <p class="notify-popup-span">
          Customer service is successfully called.
        </p>
      </div>
    </transition>

    <!-- 有人進入教室彈窗 -->
    <transition name="el-zoom-in-center">
      <div class="notify-popup" v-show="joinClassroomShow">
        <p class="notify-popup-p">{{ joinClassroomUserName }}已經進入教室</p>
        <p class="notify-popup-span">
          {{ joinClassroomUserName }} has entered the classroom.
        </p>
      </div>
    </transition>

    <!-- 設備設定彈窗彈窗 -->
    <transition name="el-fade-in">
      <div class="device-popup" v-show="deviceShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box" v-if="deviceShow">
            <div class="box-close" @click="deviceClose">
              <img src="@/assets/image/popup-close.png" alt="close" />
            </div>
            <h2 class="box-h2">Device Setting 設備設定</h2>
            <div class="box-hr"></div>
            <div class="box-label">Camera 視訊</div>
            <div class="box-select">
              <el-select
                v-model="cameraCheck"
                placeholder="Select Camera"
                @change="cameraChange"
              >
                <el-option
                  v-for="item in cameraList"
                  :key="item.deviceId"
                  :label="item.label"
                  :value="item.deviceId"
                  no-data-text="無數據"
                  loading-text="載入中"
                >
                </el-option>
              </el-select>
            </div>
            <div class="box-label">Microphone 麥克風</div>
            <div class="box-select">
              <el-select
                v-model="microphoneCheck"
                placeholder="Select Microphone"
                @change="microphoneChange"
              >
                <el-option
                  v-for="item in microphoneList"
                  :key="item.deviceId"
                  :label="item.label"
                  :value="item.deviceId"
                  no-data-text="無數據"
                  loading-text="載入中"
                >
                </el-option>
              </el-select>
            </div>
            <div class="box-label">Speaker 喇叭</div>
            <div class="box-select">
              <el-select
                v-model="speakerCheck"
                placeholder="Select Speaker"
                @change="speakerChange"
              >
                <el-option
                  v-for="item in speakerList"
                  :key="item.deviceId"
                  :label="item.label"
                  :value="item.deviceId"
                  no-data-text="無數據"
                  loading-text="載入中"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 離開教室彈窗 -->
    <transition name="el-fade-in">
      <div class="popup" v-show="quitShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box quit-box" v-if="quitShow">
            <div class="box-img">
              <img src="@/assets/image/popup-quit.png" alt="離開" />
            </div>
            <h3 class="box-h3">確定離開教室顯示</h3>
            <h5 class="box-h5">
              Are you sure you want to leave the classroom?
            </h5>
            <div class="box-btn">
              <button class="button1" @click="quitCancel">
                <p>取消</p>
                <span>Cancel</span>
              </button>
              <button @click="quitSubmit">
                <p>確定</p>
                <span>YES</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import NotificationError from "../../../static/components/NotificationError.vue";
import NotificationGuide from "../../../static/components/NotificationGuide.vue";
import moment from "moment";
export default {
  name: "teacher-header",
  props: {
    // 視訊列表
    agoraCamerasList: {
      type: Array,
      default: () => [],
    },
    // 音頻列表
    agoraMicrophoneList: {
      type: Array,
      default: () => [],
    },
    // 喇叭列表
    agoraSpeakerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      LessonRecordUrl: "",
      TBUrl: "",
      startClass: false,
      isCheckAll: false,
      stateTime: true,
      currentTime: Date.now(),
      intervalTime: null,
      initialHour: 0,
      initialMin: 0,
      initialSec: 0,
      initialMilliSec: 0,
      message: "Let the countdown begin!!",
      totalTime: this.$store.state.classTime * 60,
      timerRunning: false,
      interval: null,
      checkingTimer: null,
      checkingRecording: null,
      firstCheckIn: true,
      nowDateTime: null,
      countdownTimerDisable:
        process.env.VUE_APP_RUN_STATE == "local" ? false : true,
      enableTimerEvery1s: true,
      enableTimerEvery10s: true,
      enableTimerEvery60s: true,
      showAlertCheckIn: 0,
      checkTimerData: 0,
      autoStartClass: false,
      roomId: "",
      beginTimeStamp: 0,
      endTimeStamp: 0,
      recordState: false,
      // 打卡按鈕狀態
      checkInStatus: false,
      // 打卡彈窗狀態
      checkInShow: false,
      // 屏幕分享彈窗狀態
      screenShareShow: false,
      // 呼叫客服彈窗狀態
      serviceShow: false,
      // 呼叫客服成功提示彈窗狀態
      serviceNotifyShow: false,
      // 有人進入教室彈窗
      joinClassroomShow: false,
      // 進入教室用戶名
      joinClassroomUserName: "",
      // 設備設定彈窗狀態
      deviceShow: false,
      // 離開教室彈窗狀態
      quitShow: false,

      // 視訊選中
      cameraCheck: "",
      // 麥克風選中
      microphoneCheck: "",
      // 喇叭選中
      speakerCheck: "",
      matchingData: null,
      isRecordingTransitioning: false,
    };
  },
  async created() {
    if (!sessionStorage.getItem("ClockInTimeStamp")) {
      await this.checkInClassroomFunction();
    }
  },
  computed: {
    cameraList() {
      this.cameraCheck = this.agoraCamerasList?.[0]?.deviceId || "";
      return this.agoraCamerasList;
    },
    microphoneList() {
      this.microphoneCheck = this.agoraMicrophoneList?.[0]?.deviceId || "";
      return this.agoraMicrophoneList;
    },
    speakerList() {
      this.speakerCheck = this.agoraSpeakerList?.[0]?.deviceId || "";
      return this.agoraSpeakerList;
    },

    time: function () {
      return this.hours + " : " + this.minutes + " : " + this.seconds;
    },
    milliseconds: function () {
      return this.currentTime;
    },
    hours: function () {
      var milli = this.milliseconds;
      var hrs = Math.floor(this.totalTime / 3600);
      return hrs >= 10 ? hrs : "0" + hrs;
      // let h = Math.trunc((this.endDate - this.nowz) / 1000 / 3600);
      // return h>9?h:'0'+h;
    },
    minutes: function () {
      var min = Math.floor((this.totalTime % 3600) / 60);
      return min >= 10 ? min : "0" + min;
      // let m = Math.trunc((this.endDate - this.nowz) / 1000 / 60) % 60;
      // return m>9?m:'0'+m;
    },
    seconds: function () {
      var sec = this.totalTime % 60;
      return sec >= 10 ? sec : "0" + sec;
      // let s = Math.trunc((this.endDate - this.nowz)/1000) % 60
      // return s>9?s:'0'+s;
    },
    ...mapGetters([
      "teacher_start_class",
      "classRoomId",
      "BeginTimeStamp",
      "EndTimeStamp",
      "classTime",
      "LessonRecordUrlStore",
      "TBUrlStore",
      "onlineUsers",
    ]),
  },
  watch: {
    // 監聽客服呼叫成功彈窗 五秒後關閉
    serviceNotifyShow: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.serviceNotifyShow = false;
          }, 5000);
        }
      },
      immediate: true,
    },
    // 監聽進入教室彈窗 三秒後關閉
    joinClassroomShow: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.joinClassroomShow = false;
          }, 4000);
        }
      },
      immediate: true,
    },
    recordState: {
      deep: true,
      handler(val) {
        if (val) {
          this.$emit("clockIn", {
            beginTimeStamp: sessionStorage.getItem("BeginTimeStamp"),
            endTimeStamp: sessionStorage.getItem("EndTimeStamp"),
            classTime: this.classTime,
            timeNow: this.totalTime,
          });
        }
      },
    },
  },
  async mounted() {
    this.roomId = this.$store.state.classRoomId;
    this.beginTimeStamp = moment
      .unix(sessionStorage.getItem("BeginTimeStamp"))
      .format("LLLL");
    this.endTimeStamp = moment
      .unix(sessionStorage.getItem("EndTimeStamp"))
      .format("LLLL");

    this.LessonRecordUrl = this.$store.state.LessonRecordUrlStore;
    this.TBUrl = this.$store.state.TBUrlStore;
    await this.getClassTime();
    this.checkClassSchedule();
  },
  methods: {
    ...mapMutations(["SET_TEACHERSTART_CLASS"]),
    checkClassSchedule() {
      var beginClasstime = Number(sessionStorage.getItem("BeginTimeStamp"));
      var endClasstime = Number(sessionStorage.getItem("EndTimeStamp"));
      const classScheduler = setInterval(() => {
        const currentTimestamp = Math.floor(new Date().getTime() / 1000);
        if (
          currentTimestamp >= beginClasstime &&
          currentTimestamp <= endClasstime
        ) {
          this.screenShareOpen();
          this.countdownTimerDisable = false;
          clearInterval(classScheduler);
        }
      }, 1000);
    },
    getClassTime() {
      return this.$axios
        .get(`/classroom/info?classRoomId=${this.classRoomId}`)
        .then((response) => {
          const initialTime = this.$store.state.classTime * 60;
          const classroomInfo = {
            classRoomId: this.classRoomId,
            beginTimeStamp: this.BeginTimeStamp,
            endTimeStamp: this.EndTimeStamp,
            classTime: initialTime,
          };
          if (
            response.data.payload.classRoom != null &&
            response.data.payload.classRoom != undefined
          ) {
            const savedTime = response.data.payload.classRoom.classTime;
            // 若 DB 儲存的剩餘秒數 > 0 則恢復，否則重置為課程時長
            this.totalTime = savedTime > 0 ? savedTime : initialTime;
          } else {
            this.$axios.post(`classroom/info`, classroomInfo);
            this.totalTime = initialTime;
          }
        });
    },
    setClassTime() {
      this.$axios
        .get(`/classroom/info?classRoomId=${this.classRoomId}`)
        .then((response) => {
          const classroomInfo = {
            classRoomId: this.classRoomId,
            beginTimeStamp: this.BeginTimeStamp,
            endTimeStamp: this.EndTimeStamp,
            classTime: this.totalTime,
          };

          if (
            response.data.payload.classRoom != null ||
            response.data.payload.classRoom != undefined
          ) {
            this.$axios.put(`classroom/info`, classroomInfo);
          } else {
            this.$axios.post(`classroom/info`, classroomInfo);
          }
        });
    },
    goToTbUrl() {
      window.open(this.TBUrl, "_blank").focus();
    },
    goToLessonRecord() {
      window.open(this.LessonRecordUrl, "_blank").focus();
    },
    async checkInClassroomFunction() {
      this.isLoading = true;
      const responseCheckIn = this.$store.dispatch("checkInClassroom", {
        ClassroomId: this.$store.state.classRoomId,
      });
      return responseCheckIn;
    },
    async checkOutClassroomFunction() {
      this.isLoading = true;
      const responseCheckOut = this.$store.dispatch("checkOutClassroom", {
        ClassroomId: this.$store.state.classRoomId,
      });
      return responseCheckOut;
    },
    timerFunction() {
      this.intervalTime = setInterval(this.updateCurrentTime, 1000);
    },
    async checkAll() {
      this.timerFunction();
      if (this.isCheckAll == false) {
        this.timerRun();
        clearInterval(this.checkingTimer);
        clearInterval(this.checkingRecording);
        this.checkTimerEvery60s();
        this.setTimeEvery1s();
        this.isCheckAll = !this.isCheckAll;
      } else {
        var responseCheckOut = await this.checkOutClassroomFunction();
        if (
          responseCheckOut.data.IsSuccess == true ||
          responseCheckOut.data.IsSuccess === true
        ) {
          try {
            this.timerPause();
            let modalElement = this.$refs.teacherCommentModal;
            $(modalElement).modal("show");
            clearInterval(this.checkingTimer);
            this.checkingTimer = null;
            this.isCheckAll = false;
            // this.$emit("checkFeedback");
          } catch (error) {}
        } else {
          try {
            // alert(responseCheckOut.data.Message);
            this.$toast(
              {
                component: NotificationError,
                props: {
                  message: `${responseCheckOut.data.Message}`,
                },
              },
              {
                position: "top-right",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );

            this.isCheckAll = !this.isCheckAll;
            // this.$emit("checkFeedback")
            // this.timerPause();
            // clearInterval(this.checkingTimer);
            // this.checkingTimer = null
          } catch (error) {}
        }
      }
    },
    async checkFeedback() {
      const userId = sessionStorage.getItem("userId");
      this.matchingData = this.onlineUsers.find(
        (item) => item.FeedbackUrl && item.UserId === userId
      );
      if (this.matchingData) {
        this.checkInShow = true;
      }
    },
    setClockIn(val) {
      this.totalTime = val.timeNow;
      if (!this.isCheckAll && this.recordState && this.firstCheckIn) {
        this.isCheckAll = false;
        this.firstCheckIn = false;
        this.checkAll();
      }
      if (this.checkingTimer == null) {
        this.isCheckAll = false;
        this.checkAll();
      }
    },
    setClockOut() {
      this.checkAll();
      this.setClassTime();
    },
    timerRun() {
      this.startClass = true;
      this.timerRunning = true;
      this.message = "Greatness is within sight!!!";
      this.interval = setInterval(this.countdownTimer, 1000);
    },
    timerPause() {
      this.message = "Never quit, keep going!!";
      this.timerRunning = false;
      clearInterval(this.interval);
      this.interval = null;
    },
    countdownTimer() {
      if (this.timerRunning == true) {
        if (this.totalTime > 0) {
          this.totalTime--;
        } else {
          // const elemToEndButton = this.$refs.toEndButton;
          // elemToEndButton.click();
          // this.countdownTimerDisable = true;
        }
      }
    },
    async setTimeEvery1s() {
      if (this.isCheckAll == false && this.enableTimerEvery1s == true) {
        this.checkingTimer = setInterval(async () => {
          const maxRange =
            this.$store.state.EndTimeStamp - this.$store.state.BeginTimeStamp;
          if (
            this.totalTime <= maxRange &&
            this.totalTime >= 0 &&
            !this.screenShareShow
          ) {
            this.setClassTime();
            this.$emit("updateClassTime", {
              beginTimeStamp: sessionStorage.getItem("BeginTimeStamp"),
              endTimeStamp: sessionStorage.getItem("EndTimeStamp"),
              classTime: this.classTime,
              timeNow: this.totalTime,
            });
          }
        }, 1000);
      }
    },
    async checkTimerEvery60s() {
      if (this.isCheckAll == false && this.enableTimerEvery60s == true) {
        if (this.firstCheckIn) {
          this.screenShareOpen();
          this.firstCheckIn = !this.firstCheckIn;
        }

        this.checkingRecording = setInterval(async () => {
          await this.checkRecording();
        }, 60000);
      }
    },
    async checkRecording() {
      if (this.isRecordingTransitioning) {
        console.log("⏸️ Skipping checkRecording — transition in progress");
        return;
      }

      const dateStr2 = new Date();
      const unixTimestamp2 = Math.floor(dateStr2.getTime() / 1000);
      this.nowDateTime = unixTimestamp2;
      const maxRange =
        this.$store.state.EndTimeStamp - this.$store.state.BeginTimeStamp;

      if (
        this.totalTime <= maxRange &&
        this.totalTime >= 0 &&
        !this.screenShareShow
      ) {
        try {
          this.notificatonGuideClass(`Checking recording status...`)
          setTimeout(async () => {
            await this.$store.dispatch("aograRecordQuery");
            const response = this.$store.state.LessonRecordQuery;
            if (
              (response?.code && response?.code == "404") ||
              response?.code == 2
            ) {
              sessionStorage.removeItem("sid");
              sessionStorage.removeItem("resourceId");

              this.$emit("agoraScreenLeave");
              setTimeout(() => {
                this.screenShareOpen();
              }, 1000);
            } else if (response?.code == "53") {
              this.$emit("agoraRecordStop");
              setTimeout(() => {
                this.screenShareOpen();
              }, 1000);
            } else {
              this.notificatonGuideClass(`The recording is still running.`)
              console.log("Classroom is still on record");
            }
            console.log(
              "Current Time Display Every 60s",
              this.nowDateTime,
              this.$store.state.LessonRecordQuery
            );
          }, 2000);
        } catch (error) {}
      }
    },
    notificatonGuideClass(message) {
      this.$toast(
          {
            component: NotificationGuide,
            props: {
              message: message,
            },
          },
          {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          }
        );
    },
    // 用戶加入教室
    enteredHandle(uid) {
      // 根據uid區分角色 13老師 23學生 33客服
      const type = uid.toString().slice(0, 2);
      if (type == 13) {
        this.joinClassroomUserName = "老師";
        this.joinClassroomShow = true;
      }
      if (type == 23) {
        this.joinClassroomUserName = "學生";
        this.joinClassroomShow = true;
      }
      if (type == 33) {
        this.joinClassroomUserName = "客服";
        this.joinClassroomShow = true;
      }
    },
    // 打卡狀態切換
    checkInChange() {
      this.checkInStatus = !this.checkInStatus;
      // 打開彈窗
      // this.checkInShow = true;
    },
    // 打卡彈窗關閉（click here）
    checkInClose() {
      this.checkInShow = false;
      window.location.href = this.matchingData.FeedbackUrl;
      this.matchingData = null;
    },

    // 熒幕分享彈窗打開
    screenShareOpen() {
      this.screenShareShow = true;
    },
    // 熒幕分享彈窗關閉（分享熒幕）
    screenShareClose() {
      this.$emit("screenShareChange");
    },

    screenShareShowClose() {
      this.screenShareShow = !this.screenShareShow;
    },

    recordStateChange() {
      this.recordState = !this.recordState;
    },

    setRecordState(val) {
      this.recordState = val;
    },

    // 跳轉LR TB
    jumpClick(type) {
      if (type == "LR") {
        window.open(this.LessonRecordUrlStore, "_blank");
      } else {
        window.open(this.TBUrlStore, "_blank");
      }
    },

    // 呼叫客服彈窗打開
    serviceOpen() {
      this.serviceShow = true;
    },
    // 呼叫客服彈窗（取消）
    serviceCancel() {
      this.serviceShow = false;
    },
    // 呼叫客服彈窗（確定）
    serviceSubmit() {
      this.serviceShow = false;
      this.serviceNotifyShow = true;
      this.$store.dispatch("callCustomer", {
        ClassroomId: this.$store.state.classRoomId,
      });
    },

    // 設備設定彈窗打開
    deviceOpen() {
      this.deviceShow = true;
    },
    // 設備設定彈窗打開
    deviceClose() {
      this.deviceShow = false;
    },
    // 設備設定-視訊切換
    cameraChange() {
      this.$emit("cameraChange", this.cameraCheck);
    },
    // 設備設定-麥克風切換
    microphoneChange() {
      this.$emit("microphoneChange", this.microphoneCheck);
    },
    // 設備設定-喇叭切換
    speakerChange() {
      this.$emit("speakerChange", this.speakerCheck);
    },

    // 離開教室彈窗打開
    quitOpen() {
      this.quitShow = true;
    },
    // 離開教室彈窗（取消）
    quitCancel() {
      this.quitShow = false;
    },
    // 離開教室彈窗（確定）
    quitSubmit() {
      this.quitShow = false;
      this.isCheckAll = true;
      this.timerPause();
      this.SET_TEACHERSTART_CLASS(false);
      this.$emit("exitClassroom");
      // alert("You will leave classroom");
      // this.agoraVideoRemoteUsers = {};
      // this.agoraAudioRemoteUsers = {};
      // this.agoraCameraLeave();
      // this.agoraScreenLeave();
      // sessionStorage.clear();
      // this.$router.push("/?key=");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 0 26px;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid var(--gray-100, #f3f4f6);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-left {
    color: #000;
    font-size: 16px;
    font-family: Microsoft JhengHei;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .header-right {
    display: flex;
    align-items: center;
    .header-right-time {
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      font-size: 14px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.14px;
      img {
        margin-left: 14px;
        width: 28px;
        height: 24px;
      }
    }
    .header-right-record {
      margin-left: 16px;
      user-select: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #f00;
      font-size: 14px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.14px;
      img {
        margin-left: 8px;
        width: 16px;
        height: 16px;
      }
    }
    .header-right-icon {
      cursor: pointer;
      margin-left: 16px;
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      &:hover {
        background: var(--gray-100, #f3f4f6);
      }
    }
  }
  // 打卡彈窗樣式
  .checkIn-box {
    .box-img {
      margin-bottom: 16px;
      padding: 12px 70px;
      text-align: center;
      img {
        width: 70px;
        height: 70px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin: 4px 0 33px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      user-select: none;
      cursor: pointer;
      width: 230px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      border-radius: 4px;
      background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
      color: #fff;
      font-size: 15px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  // 熒幕分享彈窗樣式
  .screenShare-box {
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 12px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 230px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
  // 呼叫客服彈窗樣式
  .service-box {
    .box-img {
      text-align: center;
      img {
        width: 210px;
        height: 126px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 4px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 133px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .button1 {
        margin-right: 14px;
        background: #ececec;
        p {
          color: #666;
        }
        span {
          color: #666;
        }
      }
    }
  }
  // 呼叫客服成功通知
  .notify-popup {
    position: fixed;
    left: 110px;
    bottom: 80px;
    padding: 24px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
    .notify-popup-p {
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 0;
    }
    .notify-popup-span {
      margin-top: 10px;
      color: #fff;
      font-size: 16px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  // 設備設定彈窗樣式
  .device-popup {
    z-index: 1100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    .popup-box {
      padding: 40px 0;
      width: 600px;
      border-radius: 16px;
      background: #fff;
      position: relative;
      .box-close {
        cursor: pointer;
        user-select: none;
        position: absolute;
        top: 30px;
        right: 24px;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #f3f4f6;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .box-h2 {
        padding: 0 60px 20px;
        color: #000;
        font-size: 23px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .box-hr {
        width: 100%;
        height: 1px;
        background: #e9e9ea;
      }
      .box-label {
        padding: 20px 60px 14px;
        color: #989898;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .box-select {
        padding: 0 60px 10px;
        width: 100%;
        height: 50px;
        ::v-deep .el-select {
          width: 100%;
          height: 100%;
          .el-input {
            width: 100%;
            height: 100%;
            .el-input__inner {
              width: 100%;
              height: 100%;
              border: 1px solid #eee;
              color: #000;
              font-size: 16px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }
        }
      }
    }
  }
  // 離開教室彈窗樣式
  .quit-box {
    .box-img {
      margin: 0 auto 16px;
      padding: 12px 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 68px;
        height: 56px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 4px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 133px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .button1 {
        margin-right: 14px;
        background: #ececec;
        p {
          color: #666;
        }
        span {
          color: #666;
        }
      }
    }
  }
}
.header-right-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-right-icon {
    cursor: pointer;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    &:hover {
      background: var(--gray-100, #f3f4f6);
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>

<style>
.header-popover {
  min-width: 110px;
  padding: 10px !important;
}

.onoffswitch {
  position: relative;
  width: 88px;
  display: inline-block;
  margin: auto 0 auto 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch .onoffswitch-checkbox {
  display: none;
}

.onoffswitch
  .onoffswitch-checkbox:checked
  + .onoffswitch-label
  .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch
  .onoffswitch-checkbox:checked
  + .onoffswitch-label
  .onoffswitch-switch {
  right: 0px;
}

.onoffswitch .onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 20px;
  margin-bottom: 0;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  -webkit-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:before,
.onoffswitch .onoffswitch-label .onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  padding: 0;
  color: white;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:before {
  content: "END";
  padding-left: 10px;
  background-color: #9a9a9a;
  color: #252525;
  text-align: left;
  font-size: 14px;
  font-family: Roboto;
  font-style: normal;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:after {
  content: "START";
  padding-right: 10px;
  background-color: #9a9a9a;
  color: #252525;
  text-align: right;

  font-size: 14px;
  font-family: Roboto;
  font-style: normal;
}

.onoffswitch .onoffswitch-label .onoffswitch-switch {
  display: block;
  width: 18px;
  height: 18px;
  margin: 5px;
  background: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 60px;
  border: 2px solid #ffffff;
  border-radius: 24px;
  -webkit-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.blinking-icon {
  animation: blink 1s infinite;
}
</style>
